import EmailTemplateDetail from './EmailTemplateDetail';

export default EmailTemplateDetail;
